import { Injectable } from '@angular/core';
import { Review, ReviewMedia } from '../model';

@Injectable({
  providedIn: 'root'
})

export class UtilityReviewService {

	transformReviewMedia(reviewsMultimedia: Review[]): ReviewMedia[] {
		if(typeof reviewsMultimedia !== 'undefined' && reviewsMultimedia.length > 0) {
			let media: ReviewMedia[] = [];
			reviewsMultimedia.map((review: Review)=> media.push(...review.Media));
			return media = [...new Set(media)];
		}
		return [];
	}
}